import { Component, Input } from '@angular/core';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'multiple-user-avatar',
  templateUrl: './multiple-user-avatar.html',
  styleUrls: ['./multiple-user-avatar.scss']
})
export class MultipleUserAvatar {

    private extra: string = '';
    private extraTooltip: string = '';
    private _users: any = [];

    BASE_URL = environment.IMAGES_URL;

    @Input()
    set users(users: any) {
      let tmp = users.length - 3;
      this.extra = tmp > 0 ? ''+tmp : '';
      this.extraTooltip = tmp > 1 ? ' colaboradores más' : ' colaborador más';
      this._users = users.slice(0, 3);
      this._users.map(a => {
          // Remove any leading slash character in the avatar path
          let avatarPath = a.UserAvatarUrl;
          let tmp = avatarPath && avatarPath.length && (avatarPath[0] === '/' || avatarPath[0] === '\\') ?
                             avatarPath.substring(1) : (avatarPath || '');
          if(tmp){
            // And add a random suffix to avoid caching in case but only if there is no suffix already
            return this.BASE_URL + tmp + (tmp.length && tmp.indexOf('?dummy=') < 0 ?
                              '?dummy='+Math.floor(Math.random()*1000000) : '');
          }else{
            return '';
          }
        });
    }

    constructor() {
    }
}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/common/multiple-user-avatar/multiple-user-avatar.ts